import { Directive, HostListener, inject, Input } from '@angular/core';
import { FormControlDirective, FormControlName }  from '@angular/forms';

@Directive({selector: '[pinTrimField]'})
export class TrimFieldDirective {
  @Input() type: string;
  private formControlDirective = inject(FormControlDirective, {optional: true});
  private formControlName = inject(FormControlName, {optional: true});

  @HostListener('blur')
  @HostListener('keydown.enter')
  trimValue() {
    const control = this.formControlDirective?.control || this.formControlName?.control;
    if (control && typeof control.value === 'string') {
      control.setValue(control.value.trim());
    }
  }
}
